import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProvisionSheetsService extends GoogleSheetsBaseService {

  /**
   * Gets a list of provision risk names for lease accounting.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNameLeaseAccounting(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'K2';
    const endCell = 'K20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision risk names from HRSA Column III.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNameHrsaColumnIII(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'F2';
    const endCell = 'F20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision risk names from HRSA Column II.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNameHrsaColumnII(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'E2';
    const endCell = 'E20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision risk names for clinical patient summary.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNameClinicalPatientSummary(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'D2';
    const endCell = 'D20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of operational provision risk names.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNameOperational(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'C2';
    const endCell = 'C20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision action summaries.
   * @returns An observable of the action summaries.
   */
  getProvisionActionSummary(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'L2';
    const endCell = 'L20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision risk domains.
   * @returns An observable of the risk domains.
   */
  getProvisionRiskDomains(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'B2';
    const endCell = 'B30';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of provision risk names from HRSA.
   * @returns An observable of the risk names.
   */
  getProvisionRiskNamesHRSA(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'E2';
    const endCell = 'E20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of all provision names.
   * @returns An observable of the provision names.
   */
  getProvisionNames(): Observable<any> {
    const tabName = 'provisions';
    const startCell = 'A2';
    const endCell = 'A200';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}